import { render, staticRenderFns } from "./HorizontalSeparator.vue?vue&type=template&id=2b11da4a&scoped=true&functional=true&"
import script from "./HorizontalSeparator.vue?vue&type=script&lang=js&"
export * from "./HorizontalSeparator.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalSeparator.vue?vue&type=style&index=0&id=2b11da4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2b11da4a",
  null
  
)

export default component.exports